import { Lock } from "lucide-react";
import { useGetOAuthProviders } from "@/app/oauth/api/hooks";
import { MetricWidget } from "@/components/custom/widgets/metric-widget";

export function OAuthProvidersMetric() {
  const { data: oauthProvidersCount = 0 } = useGetOAuthProviders<number>(
    "project",
    {
      select: (providers) => providers?.length ?? 0,
    }
  );

  return (
    <MetricWidget
      href="/orgs/$organizationId/projects/$projectId/auth/oauth"
      icon={Lock}
      title="OAuth Apps"
      value={oauthProvidersCount}
    />
  );
}
